import { UserActions } from 'BMapsSrc/cmds/UserCmd';
import { addMenuItem } from 'BMapsSrc/menu_cmds';
import { SidePanelContainer } from './info_display/SidePanel';
import { CommandConsole } from './CommandConsole';

export function CommandPanel({
    handleClose, open, longLived,
}) {
    return (
        <SidePanelContainer
            open={open}
            handleClose={handleClose}
            longLived={longLived}
            title="Commands"
            width="20rem"
            containerStyle={{
                background: '#DCF0E6',
                // set z index to 0 to override default
                // right side panel needs to be under the bfm_viewer so that tooltips are
                // displayed on top of it. this is not true for left side panel
                // which is on top of the bfm_viewer
                zIndex: 0,
            }}
        >
            <CommandConsole />
        </SidePanelContainer>
    );
}

export function openCommandPanel() {
    UserActions.OpenSidePanel('right', {
        pageId: 'commandPanel',
        component: <CommandPanel keepOpenOnZap />,
        longLived: true,
    });
}

export function closeCommandPanel() {
    UserActions.OpenSidePanel('right', {
        pageId: 'commandPanel',
        close: true,
    });
}

export class CommandPanelLoader {
    static Init() {
        addMenuItem('Commands', 'Commands', openCommandPanel);
    }
}
